module.exports = __webpack_public_path__ + "static/media/Organizations.8f9edb3c.svg";